import type { FetchMetricsArgs } from '../../../api/types/stats.types';

import { queryKeys } from '../../../queryKeys';
import { useQuery } from '../../base';

// the registry only changes via migrations → cache for the entire session lifetime
const REGISTRY_STALE_TIME_MS = Infinity;

export function useMetricDefinitions({
  enabled = true,
  ...args
}: { enabled?: boolean } & FetchMetricsArgs = {}) {
  const { queryFn, queryKey } = queryKeys.statsRegistry.fetchMetrics(args);
  return useQuery({
    enabled,
    queryFn,
    queryKey,
    staleTime: REGISTRY_STALE_TIME_MS,
  });
}
